import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const proofOfConnectedHome: TaskDefinition = {
  taskName: onboardingTasks.ProvideProofOfConnectedHome,
  config: {
    staffDisplayName: 'Proof of Connected Home',
    appcuesModalId: '469fd3b0-415f-4b87-b355-8e9998f6a0ae',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Provided Proof of Connected Home',
    account: {
      toastMessage: 'Your proof of connected home documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed }) => ({
        title: 'Proof of Connected Home',
        incompleteSubtitle: 'Provide proof of your home security provider to keep your Connected Home discount.',
        completedSubtitle: `You have successfully submitted for review the home security provider documents for ${affectedPolicies}.`,
        actionLabel: 'Upload proof',
        modalTitle: 'Upload your proof of Connected Home',
        contentSections: [
          {
            title: 'What documents are accepted?',
            body: 'Alarm certificate, available through your home monitoring provider'
          },
          {
            title: 'When do I need to submit these documents?',
            body: `You have ${daysAllowed} days from your policy effective date to turn in verification listed above before the discount is removed.`
          }
        ]
      })
    }
  }
};
